import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function AdminMedia() {
  const [items, setItems] = useState([]);
  const fileRef = useRef(null);
  const base = process.env.REACT_APP_BACKEND_URL;

  const load = () => api.get("/admin/media").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try {
      await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Uploaded"); load();
    } catch (er) { toast.error(er.response?.data?.detail || "Upload failed"); }
    e.target.value = "";
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this media item?")) return;
    await api.delete(`/admin/media/${id}`); load();
  };

  const copy = (url) => {
    navigator.clipboard.writeText(url).then(() => toast.success("URL copied"));
  };

  return (
    <div data-testid="admin-media-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="eyebrow mb-2">Research Hub</div>
          <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Media library</h1>
        </div>
        <label className="h-10 px-3 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm inline-flex items-center gap-1.5 cursor-pointer" data-testid="media-upload-btn">
          <Upload className="w-4 h-4"/> Upload
          <input ref={fileRef} type="file" accept="image/*" onChange={upload} className="hidden"/>
        </label>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {items.map((m) => {
          const abs = `${base}${m.url}`;
          return (
            <div key={m.media_id} data-testid={`media-${m.media_id}`} className="border border-slate-200 rounded-md bg-white overflow-hidden">
              <div className="aspect-square bg-slate-50">
                <img src={abs} alt={m.original_name} className="w-full h-full object-cover"/>
              </div>
              <div className="p-2 text-xs">
                <div className="truncate text-slate-700" title={m.original_name}>{m.original_name}</div>
                <div className="mt-1 flex justify-between items-center">
                  <button onClick={() => copy(abs)} className="text-slate-500 hover:text-slate-900" title="Copy URL"><Copy className="w-3.5 h-3.5"/></button>
                  <button onClick={() => remove(m.media_id)} className="text-red-500 hover:text-red-700" title="Delete"><Trash2 className="w-3.5 h-3.5"/></button>
                </div>
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div className="col-span-full text-center text-sm text-slate-500 py-10">No media yet. Upload an image to get started.</div>}
      </div>
    </div>
  );
}
